{
  "id": "hades",
  "pantheon": "greeks",
  "name": {
    "pt-BR": "Hades",
    "en": "Hades"
  },
  "icon": "gods/hades",
  "portrait": "gods/hades-portrait",
  "modifiers": [
    {
      "target": "cost",
      "op": "mul",
      "value": 0.666,
      "scope": {
        "ids": [
          "medium-ranged-soldiers",
          "heavy-ranged-soldiers",
          "champion-ranged-soldiers",
          "ballistics",
          "burning-pitch",
          "enyos-bow-of-horror",
          "sun-ray",
          "shafts-of-plague"
        ],
        "resources": ["food", "wood", "gold", "favor"]
      },
      "note": "ArchaicAgeHades: Cost x0.666 Percent on Ballistics, Burning Pitch, Medium/Heavy/Champion Ranged Soldiers (wood, gold), Enyo's Bow of Horror (wood, favor), Sun Ray (food, favor), Shafts of Plague (gold, favor). Each tech is discounted on every resource it costs."
    }
  ],
  "powers": ["sentinel"],
  "minors": {
    "classical": ["athena", "ares"],
    "heroic": ["apollo", "aphrodite"],
    "mythic": ["artemis", "hephaestus"]
  },
  "unlocks": [
    "gastraphetoros",
    "shade-of-hades",
    "ajax",
    "achilles",
    "chiron",
    "perseus",
    "vaults-of-erebus"
  ],
  "meta": {
    "source": "Game files 19.17020 (major_gods.xml, techtree.xml)",
    "checkedAt": "2026-10-18",
    "confidence": "high",
    "note": "Also (not modelled): 20% chance (10 s delay) for fallen human soldiers to return as Shades (major_gods.xml); myth units +4% HP BasePercent in each age (+16% in Mythic); ranged soldiers and heroes +1 range and +1 LOS; buildings +2 range."
  }
}
